import React from 'react';

export default (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <svg x="5" y="8" width="14" height="8" viewBox="0 0 14.0008 8.00083">
      <path
        d="M12.2929 0.292895C12.6835 -0.0976315 13.3174 -0.0976314 13.708 0.292895C14.0984 0.683427 14.0985 1.31744 13.708 1.70794L7.70795 7.70797C7.31745 8.09847 6.68344 8.09842 6.29291 7.70797L0.292894 1.70794C-0.0976313 1.31741 -0.0976313 0.683421 0.292894 0.292895C0.683419 -0.0976315 1.31741 -0.0976315 1.70794 0.292895L7.00043 5.5854L12.2929 0.292895Z"
        fill="currentColor"
      />
    </svg>
  </svg>
);
